import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { cambiarPassword } from "../Login/Users-Api";

const dato = (valor) => (valor == null || valor === "" ? "-" : valor);

export default function Perfil({ setTitulo, userLogged }) {
  const me = userLogged?.usuarioMobEnt || {};
  const usuarioId = userLogged?.id || me.id;

  const [passwordActual, setPasswordActual] = useState("");
  const [nuevaPassword, setNuevaPassword] = useState("");
  const [repetirPassword, setRepetirPassword] = useState("");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (setTitulo) setTitulo("Mi perfil");
  }, [setTitulo]);

  const passwordOk = (msg) => toast.error(msg);
  const successOk = (msg) => toast.success(msg);

  const handleCambiarPassword = async (event) => {
    event.preventDefault();
    if (!usuarioId) {
      passwordOk("No se ha podido identificar al usuario. Inicia sesión de nuevo.");
      return;
    }
    if (!passwordActual) {
      passwordOk("Indica la contraseña actual.");
      return;
    }
    if (!nuevaPassword || nuevaPassword.length < 6) {
      passwordOk("La nueva contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (nuevaPassword !== repetirPassword) {
      passwordOk("La nueva contraseña y su confirmación no coinciden.");
      return;
    }
    if (nuevaPassword === passwordActual) {
      passwordOk("La nueva contraseña debe ser distinta de la actual.");
      return;
    }
    setEnviando(true);
    try {
      const res = await cambiarPassword(usuarioId, passwordActual, nuevaPassword);
      successOk(res?.mensaje || "Contraseña actualizada correctamente.");
      setPasswordActual("");
      setNuevaPassword("");
      setRepetirPassword("");
    } catch (e) {
      const msg = e?.response?.data?.error || "No se pudo cambiar la contraseña.";
      passwordOk(msg);
    } finally {
      setEnviando(false);
    }
  };

  if (!userLogged || !usuarioId) {
    return (
      <Alert severity="warning" sx={{ m: 3 }}>
        Debes iniciar sesión para ver tu perfil.
      </Alert>
    );
  }

  const filas = [
    ["Nombre", dato(me.nombre)],
    ["Apellidos", dato(me.apellidos)],
    ["Email", dato(me.email)],
    ["Departamento", dato(me.departamento?.nombre)],
    ["Rol", dato(me.rol?.nombre)],
  ];

  return (
    <div className="container mt-4">
      <ToastContainer position="top-left" autoClose={5000} />
      <Typography variant="h5" component="h2" gutterBottom>
        Mi perfil
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Datos personales
              </Typography>
              {filas.map(([label, valor]) => (
                <Typography key={label} variant="body1" sx={{ mb: 1 }}>
                  <strong>{label}:</strong> {valor}
                </Typography>
              ))}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Cambiar contraseña
              </Typography>
              <form onSubmit={handleCambiarPassword}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  type="password"
                  label="Contraseña actual"
                  value={passwordActual}
                  onChange={(e) => setPasswordActual(e.target.value)}
                  autoComplete="current-password"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  type="password"
                  label="Nueva contraseña (mínimo 6 caracteres)"
                  value={nuevaPassword}
                  onChange={(e) => setNuevaPassword(e.target.value)}
                  autoComplete="new-password"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  type="password"
                  label="Repite la nueva contraseña"
                  value={repetirPassword}
                  onChange={(e) => setRepetirPassword(e.target.value)}
                  autoComplete="new-password"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  disabled={enviando}
                >
                  {enviando ? <CircularProgress size={24} /> : "Cambiar contraseña"}
                </Button>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
